import { andFilter, DataWidget, DataWidgets, fromSource, fromType, notFromindices, orFilter } from "@me8eon/data_widget";
import { searchResultsDataViewWidget } from "@me8eon/search_results_data_widget";
import { appsDataWidget } from "@me8eon/apps_data_widget";

import { aiAssistDataWidget } from "@me8eon/ai_assist_data_widget";
import { filterDataWidget, newFilterDataWidget } from "@me8eon/filter_data_widget";
import { FeatureFlags } from "@me8eon/featureflags";
import { graphApiFiles } from "@me8eon/graph_api_data_sources";
import { elasticSearch } from "@me8eon/elastic_search_data_sources";
import { LayoutWithTitleAndMore } from "./title.and.more.data.widget.layout";
import { EnvironmentConfig } from "@me8eon/config";

//Note just hacked in the filters. Get them right during integration
const AppsDataWidget: DataWidget = appsDataWidget;
const sharepointLabel = "filterPage.filterMenu.m365";

const fromSharepoint = orFilter(fromSource(graphApiFiles), fromType("sharepoint"));

const SharepointWithMoreDataWidget: DataWidget = searchResultsDataViewWidget("sharepoint", fromSharepoint, LayoutWithTitleAndMore(sharepointLabel));
const SharepointDataWidget: DataWidget = searchResultsDataViewWidget("sharepoint", fromSharepoint);
const restOfElasticSearchOld: DataWidget = searchResultsDataViewWidget("restOfElasticSearch", notFromindices([EnvironmentConfig.appIndex, "m365"]));
const nonAppsFromElasticSearch: DataWidget = searchResultsDataViewWidget("restOfElasticSearch", andFilter(fromSource(elasticSearch), notFromindices([EnvironmentConfig.appIndex])));


const JiraDataWidget: DataWidget = searchResultsDataViewWidget("jira", fromType("jira"));
const ConfluenceDataWidget: DataWidget = searchResultsDataViewWidget("confluence", fromType("confluence"));
const PeopleDataWidget: DataWidget = searchResultsDataViewWidget("people", fromType("person"));
const EmailsDataWidget: DataWidget = searchResultsDataViewWidget("people", fromType("email"));
const TeamsDataWidget: DataWidget = searchResultsDataViewWidget("teams", fromType("teamsMessage"));
const MygeniusWidget: DataWidget = searchResultsDataViewWidget("myGenius", fromType("mygenius"));
const gitlabDataWidget: DataWidget = searchResultsDataViewWidget("gitlab", fromType("gitlab"));
const orderitDataWidget: DataWidget = searchResultsDataViewWidget("order-it", fromType("order-it"));
const CompassWidget: DataWidget = searchResultsDataViewWidget("compass", fromType("compass"));
const KBArticlesWidget: DataWidget = searchResultsDataViewWidget("kb_articles", fromType("kb_articles"));
const officeBuddyWidget: DataWidget = searchResultsDataViewWidget("officeBuddy", fromType("officeBuddy"));

const booleanFlaggedDataWidget = (ff: FeatureFlags, falseWidget: DataWidget, trueWidget: DataWidget): DataWidget => trueWidget;

export const allDataWidgets = (ffs: FeatureFlags): DataWidgets => ({
    ai_assist: aiAssistDataWidget,
    apps: AppsDataWidget,
    confluence: ConfluenceDataWidget,
    emails: EmailsDataWidget,
    teams: TeamsDataWidget,
    filter: booleanFlaggedDataWidget(ffs, filterDataWidget, newFilterDataWidget),
    gitlab: gitlabDataWidget,
    jira: JiraDataWidget,
    orderit: orderitDataWidget,
    mygenius: MygeniusWidget,
    people: PeopleDataWidget,
    sharepoint: SharepointDataWidget,
    sharepointWithMore: SharepointWithMoreDataWidget,
    compass: CompassWidget,
    officeBuddy: officeBuddyWidget,
    restOfElasticSearch: booleanFlaggedDataWidget(ffs, restOfElasticSearchOld, nonAppsFromElasticSearch),
    kb_articles: KBArticlesWidget,
});


